import { render } from "./AllPharmacies.vue?vue&type=template&id=1a5fa2d8&scoped=true&ts=true"
import script from "./AllPharmacies.vue?vue&type=script&lang=ts"
export * from "./AllPharmacies.vue?vue&type=script&lang=ts"

import "./AllPharmacies.vue?vue&type=style&index=0&id=1a5fa2d8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5fa2d8"]])

export default __exports__